import styled from 'styled-components';

export const StyledSandboxBanner = styled.div`
  .content {
    width: 320px;
  }
`;
